export default __webpack_public_path__ + "static/media/imgCard2.f52c465d.svg";